<template>
  <v-btn
    icon
    flat
    class="ma-0 pa-0 icone-chat"
    :title="titulo"
    @click.stop="$emit('abrir')"
  >
    <v-badge
      :color="corDoBadge"
      overlap
      :value="temBadge"
      class="icone-chat__badge"
      :class="{ 'icone-chat__badge--informativa': informativa }"
    >
      <span slot="badge" v-if="temBadge">{{ notificacao.rotulo }}</span>

      <v-icon v-if="temNaoLidas" class="icone-chat__balao">sms</v-icon>

      <svg
        v-else
        class="icone-chat__balao icone-chat__svg"
        viewBox="0 0 24 24"
        width="24"
        height="24"
        fill="currentColor"
        aria-hidden="true"
      >
        <path
          d="M12,18l-6,0l-4,4V4c0-1.1,0.9-2,2-2h16c1.1,0,2,0.9,2,2v7l-2,0V4H4v12l8,0V18z M23,14.34l-1.41-1.41l-4.24,4.24l-2.12-2.12l-1.41,1.41L17.34,20L23,14.34z"
        />
      </svg>
    </v-badge>
  </v-btn>
</template>

<script>
import statusTratativa from "@/helpers/status-tratativa.js";

export default {
  name: "IconeChatTratativa",

  props: {
    qtdNaoLidas: {
      type: Number,
      default: 0,
    },
    notificacaoInformativa: {
      type: Boolean,
      default: false,
    },
    titulo: {
      type: String,
      default: "Tratativa",
    },
  },

  computed: {
    notificacao() {
      return statusTratativa.notificacaoChat({
        qtdNaoLidas: this.qtdNaoLidas,
        notificacaoInformativa: this.notificacaoInformativa,
      });
    },
    temNaoLidas() {
      return this.notificacao.tipo === "ativa";
    },
    informativa() {
      return this.notificacao.tipo === "informativa";
    },
    temBadge() {
      return this.temNaoLidas || this.informativa;
    },
    corDoBadge() {
      return this.informativa ? "grey" : "red";
    },
  },
};
</script>

<style scoped>
.icone-chat {
  width: 36px;
  height: 36px;
}

.icone-chat .icone-chat__balao {
  color: #00456e !important;
}

.icone-chat__svg {
  display: block;
}

.icone-chat__badge >>> .v-badge__badge {
  font-size: 12px;
  height: 18px;
  width: 18px;
}

.icone-chat__badge--informativa >>> .v-badge__badge {
  font-weight: bold;
  line-height: 18px;
}
</style>



// WEBPACK FOOTER //
// src/components/shared/IconeChatTratativa.vue